import { configValue } from '#/config/appConfigUtils';

type Args = {
  url: string;
  appUrl: string;
};

export function isExternalURL({ url, appUrl }: Args) {
  if (!url) return;

  // ignore mailto
  if (url.startsWith('mailto:')) {
    return false;
  }

  // links starting with `/` are relative to our website
  if (url.startsWith('/')) return false;

  // links that are relative to the current url, like anchors, query params
  if (url.startsWith('#') || url.startsWith('?')) {
    return false;
  }

  const domain = (u: string) =>
    u.replace('http://', '').replace('https://', '').split('/')[0];

  return Boolean(domain(url)) && domain(url) !== domain(appUrl);
}

/**
 * @deprecated This function relies on global state, use `isomorphicIsExternalURL` instead
 */
export function legacyIsExternalURL(url: string) {
  return isExternalURL({
    url,
    appUrl: configValue('idealist', 'appUrl') ?? '',
  });
}
